import React from 'react';
import PropTypes from 'prop-types';
import fetchResourceById from 'components/hoc/fetchResourceById';
import { fetchProduct } from 'store/actions/products/fetchProducts';
import LoadingCard from 'components/loading/LoadingCard';
import ResourceNotFound from 'pages/NotFound/ResourceNotFound';
import ProductShowField from './ProductShowField';
import translate from 'components/hoc/translate';
import compose from 'recompose/compose';

function ProductFieldContainer(props) {
    const {
        data,
        resourceFetchFailed,
        resourceFetchLoading,
    } = props;

    if (resourceFetchLoading) {
        return <LoadingCard />;
    }

    if (resourceFetchFailed) {
        return <ResourceNotFound />;
    }

    if (!data) {
        return null;
    }

    return (
        <ProductShowField label={ translate('fields.product') } product={ data } />
    );
}

ProductFieldContainer.propTypes = {
    data: PropTypes.object,
    resourceFetchFailed: PropTypes.bool.isRequired,
    resourceFetchLoading: PropTypes.bool.isRequired,
};

const enhance = compose(
    fetchResourceById({
        resource: 'products',
        action: fetchProduct,
    }),
    translate,
);

export default enhance(ProductFieldContainer);



// WEBPACK FOOTER //
// ./src/components/show/ProductFieldContainer.js